import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { toastOncePerDay } from "../utils/toastOncePerDay";

export default function InstalacionPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [showIOSModal, setShowIOSModal] = useState(false);

  const servicioActivo = localStorage.getItem("servicioActivo");

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    // eslint-disable-next-line
    const isAndroid = /Android/i.test(ua);

    const isChromeIOS = /CriOS/i.test(ua);
    const isFirefoxIOS = /FxiOS/i.test(ua);
    const isEdgeIOS = /EdgiOS/i.test(ua);
    const isOperaIOS = /OPiOS/i.test(ua);

    const isSafariIOS =
      isIOS && !isChromeIOS && !isFirefoxIOS && !isEdgeIOS && !isOperaIOS;

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      navigator.standalone === true;

    // 🔔 iOS pero no Safari
    if (isIOS && !isSafariIOS) {
      toastOncePerDay("pwa-ios-no-safari", () => {
        toast.info("Para una mejor experiencia, abre esta app desde Safari 🧭");
      });
    }

    // 🔔 iOS Safari sin instalar
    if (isIOS && isSafariIOS && !isStandalone) {
      setShowButton(true);

      setTimeout(() => {
        toastOncePerDay("pwa-ios-install", () => {
          toast.info("Puedes agregar esta app a inicio 📱✨");
        });
      }, 1500);
    }

    // 🔔 Android / Chrome
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);

      toastOncePerDay("pwa-install-prompt", () => {
        toast.info("Instala esta app en tu pantalla de inicio 📲✨");
      });
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const instalar = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowButton(false);
  };

  const abrirGuiaIOS = () => {
    setShowIOSModal(true);
  };

  if (!showButton) return null;

  return (
    <>
      <button
        onClick={deferredPrompt ? instalar : abrirGuiaIOS}
        className={`fixed right-6 ${
          servicioActivo ? "bottom-24" : "bottom-6"
        } bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg z-40`}
      >
        Instalar App
      </button>

      {showIOSModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-xl w-80 text-center">
            <h2 className="text-lg font-bold mb-2">Agregar a Inicio (iOS)</h2>
            <p className="text-sm mb-3">
              En iPhone debes agregar esta app manualmente:
            </p>
            <p className="text-sm mb-3">
              1️⃣ Toca <b>Compartir</b> (⬆️) <br />
              2️⃣ Selecciona <b>“Agregar a pantalla de inicio”</b> 📱✨
            </p>

            <button
              onClick={() => setShowIOSModal(false)}
              className="mt-2 bg-gray-700 text-white px-3 py-1 rounded-lg"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
